import React, { useContext } from "react";
import { useTranslation } from "react-i18next";
import { StatePositionContext } from "../../../../../context/PositionContext";
import { ApplicationContext } from "../../../ApplicationContext";
import { Col, Grid, Row } from "../../../../../../components/Grid";
import { InputLabel } from "../../../../../../components/Input/Input";
import { convertPeriod } from "../../util";
import BinaryChoiceSelector from "./BinaryChoiceSelector";

const BinaryChoices = () => {
  //LANGUAGE
  const { t } = useTranslation();

  //POSTION STATE
  const { position } = useContext(StatePositionContext);
  const binaryChoices = position?.binaryChoices || [];

  //APPLICATION STATE
  const { state, dispatch } = useContext(ApplicationContext);
  const binaryChoiceValues = state.application.binaryChoices || {};

  const persistBinaryChoiceValue = (choice, value) => {
    const normalizedValue = value === "true";

    dispatch({
      type: "update_field",
      payload: {
        name: `binaryChoices.${convertPeriod(choice, true)}`,
        value: normalizedValue,
      },
    });
  };

  return (
    <Grid>
      <Row>
        <Col size={24}>
          <InputLabel required={true} boldLabel={true}>
            {t("application_form.binaryChoices_label", "Yes/No Questions")}
          </InputLabel>
        </Col>
      </Row>
      <Row mb={20}>
        {binaryChoices.length > 0 ? (
          <Col size={24}>
            {binaryChoices.map((choice, index) => {
              const choiceKey = convertPeriod(choice, true);
              const currentValue = binaryChoiceValues[choiceKey] ?? "";

              return (
                <BinaryChoiceSelector
                  key={`${choice}-${index}`}
                  id={`binary-choice-${choiceKey}-${index}`}
                  label={choice}
                  name={`binaryChoices.${choiceKey}`}
                  value={currentValue}
                  required
                  yesLabel={t("common.yes", "Yes")}
                  noLabel={t("common.no", "No")}
                  onChange={(e) => persistBinaryChoiceValue(choice, e.target.value)}
                />
              );
            })}
          </Col>
        ) : null}
      </Row>
    </Grid>
  );
};

export default BinaryChoices;
